import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/LinkUnlinkOutline.tsx
import React from "react";
var SvgLinkUnlinkOutline, LinkUnlinkOutline_default;
var init_LinkUnlinkOutline = __esm({
  "src/icons/LinkUnlinkOutline.tsx"() {
    SvgLinkUnlinkOutline = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "m17.657 14.829-1.414-1.415L17.657 12A4 4 0 1 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.415Zm-2.828 2.828-1.415 1.414a6 6 0 0 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 0 0 12 17.657l1.414-1.414 1.415 1.414Zm0-9.9 1.414 1.415-7.071 7.07-1.415-1.413 7.072-7.072ZM5.775 2.293l1.932-.518L8.743 5.64l-1.932.518-1.036-3.864Zm9.483 16.068 1.932-.518 1.035 3.864-1.932.518-1.035-3.864ZM2.293 5.775l3.864 1.036-.518 1.932-3.864-1.036.518-1.932Zm16.068 9.483 3.864 1.035-.518 1.932-3.864-1.035.518-1.932Z"
        }
      )
    );
    LinkUnlinkOutline_default = SvgLinkUnlinkOutline;
  }
});

export {
  LinkUnlinkOutline_default,
  init_LinkUnlinkOutline
};
